import { render, staticRenderFns } from "./PageMainLegalDocument.vue?vue&type=template&id=6f4edc88&scoped=true&"
import script from "./PageMainLegalDocument.vue?vue&type=script&lang=js&"
export * from "./PageMainLegalDocument.vue?vue&type=script&lang=js&"
import style0 from "./PageMainLegalDocument.vue?vue&type=style&index=0&id=6f4edc88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4edc88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VContainer})
